import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV_ITEMS = [
  { label: "About", href: "/about" },
  { label: "Blog", href: "/blog" },
  { label: "Contact Me", href: "/contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      data-testid="main-header"
      className={`glass-header fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? "scrolled" : ""}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="flex items-center justify-between h-20">
          <Link
            to="/"
            data-testid="logo-link"
            className="font-['Playfair_Display'] text-xl md:text-2xl font-medium text-[#2D2D2D] tracking-tight"
          >
            Dr. Erika Tajra
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-10" data-testid="desktop-nav">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.label}
                to={item.href}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-sm font-medium tracking-widest uppercase text-[#6B6B6B] hover:text-[#D4AF37] transition-colors"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/apply"
              data-testid="nav-book-now"
              className="btn-gold text-xs"
            >
              Apply Now
            </Link>
          </nav>

          {/* Mobile Hamburger */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileOpen && (
        <div
          data-testid="mobile-nav"
          className="md:hidden bg-[#FDFBF7] border-t border-[rgba(45,45,45,0.08)] px-6 py-8"
        >
          <nav className="flex flex-col gap-6">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.label}
                to={item.href}
                className="text-sm font-medium tracking-widest uppercase text-[#6B6B6B] hover:text-[#D4AF37] transition-colors"
              >
                {item.label}
              </Link>
            ))}
            <Link to="/apply" className="btn-gold text-xs text-center mt-4">
              Apply Now
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
